import React from 'react';
import PermissionCluster from '../../domain/enums/PermissionCluster';
import PermissionClusterDescriptions from '../../constants/PermissionClustersDescriptions';
import { useTranslation } from 'react-i18next';
import { useConsentConfiguration } from '../../hooks/queryHooks';
import FeatherIcon from 'feather-icons-react';

interface IProps {
  reconfirmation?: boolean;
  replacementTokens: { [k: string]: any };
}

const PermissionClustersAccordion: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();
  const { consentConfiguration } = useConsentConfiguration();
  const allContent = [];

  // Add default permission content
  const defaultPermission = PermissionClusterDescriptions.get(PermissionCluster.AccountDetails);

  if (defaultPermission) {
    allContent.push(...defaultPermission.content.map(contentPart => t(contentPart)));
  }

  if (!props.reconfirmation && consentConfiguration?.permissionClusters) {
    for (const permissionCluster of consentConfiguration.permissionClusters) {
      if (permissionCluster !== PermissionCluster.AccountDetails) {
        const desc = PermissionClusterDescriptions.get(permissionCluster);
        if (desc) {
          allContent.push(...desc.content.map(contentPart => t(contentPart, props.replacementTokens)));
        }
      }
    }
  }

  if (props.reconfirmation) {
    const clusters = [PermissionCluster.Balances, PermissionCluster.Transactions];
    for (const permissionCluster of clusters) {
      const desc = PermissionClusterDescriptions.get(permissionCluster);
      if (desc) {
        allContent.push(...desc.content.map(contentPart => t(contentPart, props.replacementTokens)));
      }
    }
  }

  return (
    <div data-testid="permission_clusters" className="grid grid-cols-1 md:grid-cols-2 gap-4 md:mb-10 mb-10">
      {allContent.map((content, index) => (
        <div key={index} className="flex gap-2 flex-row">
          <p className="flex-shrink-0">
            <FeatherIcon icon="check-square" className="w-6 h-7 text-gray-500" />
          </p>
          <p className="text-base"> {t<string>(`${content}`)}</p>
        </div>
      ))}
    </div>
  );
};

export { PermissionClustersAccordion };
export default PermissionClustersAccordion;
